"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CC_FEE_PERCENT = void 0;
/**
 * Central defaults for credit card processing fees.
 *
 * Note: `creditCardFeePercent` in DB/code is stored as a percentage (e.g. `2` for `2%`),
 * while some UI/payment calculations use the decimal form (e.g. `0.02`).
 */
exports.DEFAULT_CC_FEE_PERCENT = 2; // 2%
